import { ForwardedRef, forwardRef } from 'react';
import { Typography } from '@material-ui/core';

import { useDisplayStyles } from './Typography.styles';
import { TypographyProps } from './Typography.props';

export const Display = forwardRef(
  ({ className = '', ...props }: TypographyProps, ref: ForwardedRef<HTMLElement>): JSX.Element => {
    const styles = useDisplayStyles();

    return <Typography classes={styles} className={className} {...props} {...{ ref }} />;
  },
);

Display.displayName = 'Typography.Display';
